<template>
  <div class="flex justify-center items-center flex-col">
    <img
      v-if="roomsNumber === 0"
      :src="'/build/images/search/venue-not-found.svg'"
      alt="Venue not found"
      class="pb-6 -mr-4"
    >

    <div class="font-semibold text-xl mb-4 text-center">
      Sorry, we couldn't find
      {{ roomsNumber === 0 ? 'any' : 'more' }}
      venues matching your criteria.
    </div>

    <div
      v-if="capacitySelected || priceSelected"
      class="mb-4 mt-2 flex flex-col sm:flex-row items-center"
    >
      <BaseButton
        v-if="capacitySelected"
        class="sm:mr-4"
        @click="resetCapacity"
      >
        See venues with different capacity
      </BaseButton>

      <BaseButton
        v-if="priceSelected"
        class="mt-3 sm:mt-0"
        @click="resetPrice"
      >
        See venues with different price
      </BaseButton>
    </div>

    <div
      v-if="capacitySelected || priceSelected"
      class="line-around mb-6 mt-2"
    >
      or
    </div>

    <div class="text-center">
      You can try to
      <BaseButton
        color="inverse"
        class="p-1 -m-1"
        @click="resetZoom"
      >
        zoom out on the map
      </BaseButton>,
      change some filters, or
      <BaseButton
        color="inverse"
        class="p-1 -m-1"
        data-test-id="clear-filters"
        @click="resetAllFilters"
      >
        clear all filters
      </BaseButton>.
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'SearchEmptyState',
  components: { BaseButton },

  props: {
    roomsNumber: {
      type: Number,
      required: true,
    },
  },

  computed: {
    capacitySelected() {
      return !!this.$store.state.filters.people.value;
    },
    priceSelected() {
      return !this.$store.getters.isPriceFilterDefault;
    },
  },

  methods: {
    track({ action, label }) {
      App.track.all({
        category: 's-search-page-filters-reset',
        action,
        label,
        value: this.roomsCount,
      });
    },

    resetCapacity() {
      this.track({
        action: 'clear-capacity-clicked',
      });

      this.$store.commit('updatePeople', null);
      this.$store.dispatch('applyFilters', {
        changedFilter: 'People',
        value: null,
      });

      this.$store.dispatch('scrollTop');
    },

    resetPrice() {
      this.track({
        action: 'clear-price-clicked',
      });

      const defaultPrice = this.$store.getters.currentPriceMethodBoundaries;

      this.$store.commit('priceChange', defaultPrice);
      this.$store.dispatch('applyFilters', {
        changedFilter: 'Price',
        value: defaultPrice,
      });

      this.$store.dispatch('scrollTop');
    },

    resetAllFilters() {
      this.track({
        action: 'reset-filters-clicked',
        label: 'new',
      });

      this.$store.commit('resetFilters');
      this.$store.dispatch('resetMapToInitialLocationWithoutRefresh');

      this.$store.dispatch('applyFilters', {
        changedFilter: 'reset',
        value: null,
      });

      this.$store.dispatch('scrollTop');
    },

    resetZoom() {
      this.track({
        action: 'reset-map-clicked',
      });

      this.$store.dispatch('resetMapToInitialLocation');
      this.$store.dispatch('scrollTop');
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/base/variables";
@use "@sass/design-system/variables" as ds-variables;

.line-around {
  padding: 0 16px;
  background-color: ds-variables.$white;
  position: relative;

  &:before,
  &:after {
    content: '';
    position: absolute;
    height: 1px;
    bottom: 9px;
    background-color: ds-variables.$grey-300;
    width: 40px;
  }

  &:before {
    left: -40px;
  }

  &:after {
    right: -40px;
  }
}
</style>
